import { HiPencilAlt } from "react-icons/hi";
import { css } from "../../../styled-system/css";
import { VStack } from "../../../styled-system/jsx";
import InsightsFeed from "./InsightsFeed";
import SidebarItem from "./SidebarItem";
import Section from "./Section";
import { useTranslation } from "react-i18next";

const ConversationsSidebar = ({
  onStartNewConversation,
  currentConversation,
  setCurrentConversation,
  conversationData,
  client,
  setTab,
  isFullScreen = false,
}) => {
  const { t } = useTranslation(["common", "chat"]);
  return (
    <VStack
      alignItems="flex-start"
      width="100%"
      padding="10px"
      minHeight="0"
      height={"full"}
      className={css({
        backgroundColor: "white",
        borderRight: "1px solid #ddd",
      })}
    >
      {isFullScreen && (
        <div
          className={css({
            fontSize: "16px",
            fontWeight: "bold",
            color: "black",
            padding: "8px 5px 8px 5px",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          })}
        >
          <span>{t(($) => $.chat["Conversations"])}</span>
          <button
            className={css({
              backgroundColor: "white",
              fontSize: "18px",
              fontWeight: "bold",
              color: "black",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              border: "none",
              cursor: "pointer",
              _hover: {
                backgroundColor: "#f0f0f0",
              },
            })}
            onClick={() => setCurrentConversation(null)}
            title={t(($) => $.chat["New Conversation"])}
          >
            <HiPencilAlt />
          </button>
        </div>
      )}
      <VStack alignItems="flex-start" width="100%" flexGrow={1} marginBottom="16px" minHeight={0}>
        <Section label={t(($) => $.chat["Chats"])} count={conversationData ? conversationData.data.count : 0}>
          {!conversationData && <div>{t(($) => $.common["Loading..."])}</div>}
          <SidebarItem
            active={!currentConversation}
            onClick={() => {
              setCurrentConversation(null);
              client.invalidateQueries({ queryKey: ["clio-chat"] });
              if (setTab) setTab("chat");
            }}
            label={t(($) => $.chat["New Conversation"])}
          />

          {conversationData &&
            conversationData.data.results.map((conversation) => (
              <SidebarItem
                active={conversation.external_id === currentConversation}
                key={conversation.id}
                createdOn={conversation.created_on}
                onClick={() => {
                  setCurrentConversation(conversation.external_id);
                  client.invalidateQueries({ queryKey: ["clio-chat"] });
                  if (setTab) setTab("chat");
                }}
                label={conversation.title || t(($) => $.chat["New Conversation"])}
              />
            ))}
        </Section>
        <InsightsFeed onStartNewConversation={onStartNewConversation} />
      </VStack>
    </VStack>
  );
};

export default ConversationsSidebar;
